import { render, staticRenderFns } from "./talk-input.vue?vue&type=template&id=791614b5&"
import script from "./talk-input.vue?vue&type=script&lang=js&"
export * from "./talk-input.vue?vue&type=script&lang=js&"
import style0 from "./talk-input.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports